import * as yup from "yup";

export const ChalanValidationSchema = yup.object().shape({
    work_order: yup
        .object()
        .shape({
            id: yup.number().required("Work Order is Required"),
            label: yup.string(),
            name: yup.string(),
        })
        .typeError("Please select Work order"),
    chalan_date: yup.date().required("Chalan date is Required").nullable(),
    remark: yup.string().max(100, "Remark not more than 100 characters."),
    order_items: yup.array().of(
        yup.object().shape({
            product_expiry_date: yup.date().required("Expiry date is Required").nullable(),
            receive_quantity: yup.number().required("Receive Quantity is Required"),
            sale_price: yup.number().required("Sale price is Required"),
            remark: yup.string().max(50, "Remark not more than 50 characters."),
        })
    ),
});
